import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-column-visibility',
  templateUrl: './column-visibility.component.html',
  styleUrls: ['./column-visibility.component.scss']
})
export class ColumnVisibilityComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';


  @Input() columns = [];
  columnsVisble:any=[];
  @Output() closePopup = new EventEmitter();
    @Input() filterType: boolean = false;


  ngOnInit(): void {

    this.columnsVisble = [...this.columns]; 
   
    let index =this.columnsVisble.findIndex(mapping => mapping.name === 'Action');

    if(index>-1){
      this.columnsVisble.splice(index, 1);
    }
   

  }


  toggleColumnVisibility(column, event) {
    event.stopPropagation();
    column.visible = !column.visible;

  }
  
  callclosepopup() {
    this.closePopup.emit(true)
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    constructor(private router: Router) {
        this.url = this.router.url || '';
            this.router.events
              .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
              .subscribe(() => { this.url = this.router.url || ''; });
    }
}
